import { apiConnector } from "../apiconnector";
import { catalogData } from "../apis";

export const getCatalogPageData = async (categoryId) => {
  let result = null;
  try {
    const response = await apiConnector(
      "POST",
      catalogData.CATALOGPAGEDATA_API,
      { categoryId }
    );
    if (!response?.data?.success)
      throw new Error("Could not fetch catalog page data");
    result = response.data.data;
  } catch (error) {
    console.log("CATALOG PAGE DATA API ERROR:", error.message);
    // Return null so callers can distinguish "failed" from "loaded empty"
  }
  return result;
};
